import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { Chat16Regular } from "@fluentui/react-icons";
import { useSetAtom } from "jotai";
import * as React from "react";
import { resetChatAtom } from "@/state";

export default function Toolbar() {
  const styles = useStyles();

  const handleNewChatButtonClick = useSetAtom(resetChatAtom);

  return (
    <div className={styles.container}>
      <Button type={"button"} onClick={handleNewChatButtonClick}>
        <div className={styles.button__content}>
          <Chat16Regular />
          New Chat
        </div>
      </Button>
    </div>
  );
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    paddingBottom: "8px",
  },

  button__content: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    color: tokens.colorNeutralForeground1,
  },
});
